var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99688 8.40078L2.09688 13.3008C1.91354 13.4841 1.68021 13.5758 1.39688 13.5758C1.11354 13.5758 0.880208 13.4841 0.696875 13.3008C0.513542 13.1174 0.421875 12.8841 0.421875 12.6008C0.421875 12.3174 0.513542 12.0841 0.696875 11.9008L5.59688 7.00078L0.696875 2.10078C0.513542 1.91745 0.421875 1.68411 0.421875 1.40078C0.421875 1.11745 0.513542 0.884115 0.696875 0.700781C0.880208 0.517448 1.11354 0.425781 1.39688 0.425781C1.68021 0.425781 1.91354 0.517448 2.09688 0.700781L6.99688 5.60078L11.8969 0.700781C12.0802 0.517448 12.3135 0.425781 12.5969 0.425781C12.8802 0.425781 13.1135 0.517448 13.2969 0.700781C13.4802 0.884115 13.5719 1.11745 13.5719 1.40078C13.5719 1.68411 13.4802 1.91745 13.2969 2.10078L8.39687 7.00078L13.2969 11.9008C13.4802 12.0841 13.5719 12.3174 13.5719 12.6008C13.5719 12.8841 13.4802 13.1174 13.2969 13.3008C13.1135 13.4841 12.8802 13.5758 12.5969 13.5758C12.3135 13.5758 12.0802 13.4841 11.8969 13.3008L6.99688 8.40078Z",
    fill: "#39848A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClose);
export default __webpack_public_path__ + "static/media/btn_close.c4a6f7e62c5e00f66190b7033a62cdc0.svg";
export { ForwardRef as ReactComponent };